function openModal(id) {
    closeModal();
    document.getElementById(id)?.classList.add('popup--open');
    document.documentElement.classList.add('disable-body-scroll');
    document.body.classList.add('jw-modal-open');
}

function closeModal() {
    document.querySelector('.section-od-popup.popup--open')?.classList.remove('popup--open');
    document.documentElement.classList.remove('disable-body-scroll');
    document.body.classList.remove('jw-modal-open');
}

window.addEventListener('load', function() {
    document.addEventListener('click', event => {
        if (event.target.classList.contains('popup__overlay') || event.target.closest('.popup__close-button').classList.contains('popup__close-button')) {
            closeModal();
        }
    });
});